import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyDatetimepicker2Component } from './formly-datetimepicker2.component';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { MatButtonModule } from '@angular/material/button';

export const FieldTypeDatetimePicker2 = 'datetimepicker2';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    MatInputModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    FormlyModule.forChild({
      types: [
        {
          name: FieldTypeDatetimePicker2,
          component: FormlyDatetimepicker2Component,
          // wrappers: ['form-field'],
        },
      ],
    }),
    MatButtonModule,
  ],
  declarations: [FormlyDatetimepicker2Component],
})
export class FormFieldsDatetimepicker2Module {}
